
namespace GeniuzPOS.Administration {

    @Serenity.Decorators.registerClass()
    export class PsSalesVatTypesDialog extends Serenity.EntityDialog<PsSalesVatTypesRow, any> {
        protected getFormKey() { return PsSalesVatTypesForm.formKey; }
        protected getIdProperty() { return PsSalesVatTypesRow.idProperty; }
        protected getLocalTextPrefix() { return PsSalesVatTypesRow.localTextPrefix; }
        protected getNameProperty() { return PsSalesVatTypesRow.nameProperty; }
        protected getService() { return PsSalesVatTypesService.baseUrl; }
        protected getDeletePermission() { return PsSalesVatTypesRow.deletePermission; }
        protected getInsertPermission() { return PsSalesVatTypesRow.insertPermission; }
        protected getUpdatePermission() { return PsSalesVatTypesRow.updatePermission; }

        protected form = new PsSalesVatTypesForm(this.idPrefix);

    }
}